import LandingPage from "./pages/LandingPage/LandingPage";
// import ReactGA from 'react-ga4';
// import { useEffect } from 'react';
// import { BrowserRouter as Router, useLocation } from 'react-router-dom';

function App() {
  // useEffect(() => {
  //   // Inicializa o GA4
  //   ReactGA.initialize('G-JMVE77S5Q6');
  // }, []);

  return (
    <LandingPage/>
    // <Router>
    //   <AppContent />
    // </Router>
  );
}

// function AppContent() {
//   const location = useLocation();

//   useEffect(() => {
//     // Rastreia mudanças de página
//     ReactGA.send({ hitType: 'pageview', page: location.pathname });
//   }, [location]);

//   return <LandingPage />;
// }

export default App;